<script lang="ts" setup>
import { getCustomReportUrl } from '@/app/core/services/reports'
import { onMounted, ref } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { usePayrollChange } from '@/app/core/composable/routes/useChangePayroll'
import { DBtn } from 'front-library'
usePayrollChange(() => back())

const router = useRouter()
const route = useRoute()
const metabaseUrl = ref('')
const { t } = useI18n()

onMounted(async () => {
  if (route.params?.code) {
    const code = atob(route.params.code.toString())
    const reportNumber = code.split('-')?.[1] || '0'
    metabaseUrl.value = await getCustomReportUrl(reportNumber)
  }
})

const back = () => {
  router.back()
}
</script>
<template>
  <div class="h-full px-5 pt-16 pb-5 flex flex-col">
    <iframe :src="metabaseUrl" title="Dashboard" class="w-full h-full"></iframe>
    <div class="w-full bg-white p-5">
      <DBtn
        type="button"
        color="secondary"
        @click="back"
        class="px-5 py-2 font-semibold cursor-pointer"
        v-html="t('form.button.back')" />
    </div>
  </div>
</template>
